<template>

  <svg ref="svgEl" v-html="svg"></svg>

</template>

<script>
  export default {
    name: 'svgIcon',
    props: {
      basePath: {
        type: String,
        default: '/assets',
      },
      mode: {
        type: String,
        default: 'include',
      },
      fileName: {
        type: String,
        default: '/svg-symbols.svg',
      },
      icon: {
        type: String,
        required: true,
      },
      size: {
        default: 16,
      },
    },
    computed: {
      style () {
        return '';
        // return `width: ${ this.size }px; height: ${ this.size }px`;
      },
      svg () {

        let svgPath = `#${ this.icon }`;

        if (this.mode === 'file') {
          svgPath = `${ this.basePath }/${ this.fileName }#${ this.icon }`;
        }

        return `<use href="${svgPath}"></use>`;
      },
    },
    mounted () {
      // this.$refs.svgEl.innerHTML = '<h1>TESTTEST</h1>';
      setTimeout(() => {
        this.$refs.svgEl.innerHTML = this.svg;
      }, 1000);

    },
  };
</script>

<style scoped lang="stylus">
  /*.icon {*/
  /*color: inherit;*/
  /*display: inline-block;*/
  /*vertical-align: middle;*/
  /*fill: currentColor;*/
  /*}*/
</style>
